import React, { PropsWithChildren, useCallback, useMemo, useState } from 'react'
import { AccountByUserContext } from './index.context'
import { MenuProps, Typography } from 'antd'
import { DeleteIcon, EyeIcon, PenIcon, UserIcon } from 'src/assets/icons'
import { useNavigate } from 'react-router-dom'
import { menuUrls } from 'src/app/shared/constants/menu.constants'
import { colorText, error } from 'src/app/themes/primaryThemeDefault'
import { useTranslation } from 'react-i18next'
import { IGetAccountListResponse } from 'src/app/shared/models/clientSetup.model'
import { getAccountByUser } from 'src/app/shared/services/AccountService'
import { IAccountByUser } from 'src/app/shared/models/accountSetup.model'
import { STATUS_CODES } from 'src/app/shared/constants/common.constants'

const AccountByUserProvider: React.FC<PropsWithChildren> = (props) => {
  const { children } = props
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [accountByUser, setAccountByUser] = useState<IAccountByUser[]>([])
  const [total, setTotal] = useState<number>(0)
  const [isGettingAccountByUser, setIsGettingAccountByUser] = useState<boolean>(false)

  const getAccountByUserList = useCallback(async (payload: any) => {
    try {
      setIsGettingAccountByUser(true)
      const res = await getAccountByUser(payload)
      if (res.statusCode === STATUS_CODES.SUCCESS) {
        setAccountByUser(res.data.items)
        setTotal(res.data.total)
      }
    } catch (error) {
      console.log('ERROR: ', error)
    } finally {
      setIsGettingAccountByUser(false)
    }
  }, [])

  const getActionItems = useCallback(
    (rowData: any): MenuProps['items'] => {
      return [
        {
          key: '1',
          label: (
            <Typography.Text style={{ fontSize: '14px' }}>{t('AccountSetup:actions.view_account')}</Typography.Text>
          ),
          icon: <EyeIcon />,
          onClick: () => {
            console.log('DATA: ', rowData)
            if (rowData?.id) navigate(`${menuUrls.accountSetup}/view/${rowData?.id}`)
          },
        },
        {
          key: '2',
          label: (
            <Typography.Text style={{ fontSize: '14px' }}>{t('AccountSetup:actions.edit_account')}</Typography.Text>
          ),
          icon: <PenIcon />,
          onClick: () => {
            if (rowData?.id) navigate(`${menuUrls.accountSetup}/edit/${rowData?.id}`)
          },
        },
        {
          key: '3',
          label: (
            <Typography.Text style={{ fontSize: '14px', color: colorText }}>
              {t('AccountSetup:actions.view_users_for_account')}
            </Typography.Text>
          ),
          icon: <UserIcon />,
          onClick: () => {
            if (rowData?.id) navigate(`/account-setup/users-for-account`)
          },
        },
        {
          key: '4',
          label: (
            <Typography.Text style={{ fontSize: '14px', color: error }}>
              {t('AccountSetup:actions.delete_account')}
            </Typography.Text>
          ),
          icon: <DeleteIcon />,
          onClick: () => {
            if (rowData?.id) {
              // setIsModalConfirmDeleteOpened(true)
            }
          },
        },
      ]
    },
    [t, navigate],
  )

  const handleUploadAndCreate = useCallback(() => {
    console.log('UPLOAD AND CREATE')
  }, [])

  const handleUploadAndEdit = useCallback(() => {
    console.log('UPLOAD AND EDIT')
  }, [])

  const handleSearch = useCallback(
    async (value: Partial<IGetAccountListResponse>) => {
      await getAccountByUserList(value)
    },
    [getAccountByUserList],
  )

  // table download states
  const uploadDropdownItems: MenuProps['items'] = useMemo(
    () => [
      {
        key: 'pdf',
        label: t('ClientSetup:account_list.upload_and_create_account'),
        onClick: handleUploadAndCreate,
      },
      {
        key: 'excel',
        label: t('ClientSetup:account_list.upload_and_edit_account'),
        onClick: handleUploadAndEdit,
      },
    ],
    [handleUploadAndCreate, handleUploadAndEdit, t],
  )
  return (
    <AccountByUserContext.Provider
      value={{
        uploadDropdownItems,
        isLoading: isGettingAccountByUser,
        accountByUser,
        total,
        getActionItems,
        handleSearch,
      }}
    >
      {children}
    </AccountByUserContext.Provider>
  )
}

export default AccountByUserProvider
